<template>
  <div class="results-view">
    <Results />
  </div>
</template>

<script>
import Results from '@/components/Results.vue'

export default {
  components: {
    Results,
  },
}
</script>
<style scoped>
.results-view {
  min-height: 100%;
}
</style>
